var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCateringOff = function SvgCateringOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 138.8 66.8"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".catering_off_svg__st0{display:none}.catering_off_svg__st2{fill:#e2b128}.catering_off_svg__st2,.catering_off_svg__st3{display:inline}.catering_off_svg__st4{fill:#e2b128}.catering_off_svg__st5{fill:#010101}.catering_off_svg__st6{fill:#e2b128;stroke:#e1b128;stroke-width:.75;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "catering_off_svg__chief_x5F_eng"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.4 63.3 118.9-.1c1.1 0 2.2-.4 2.7-1 0 0 8.3-13.2 8.3-13.9V19.5c0-.8-8.3-14.1-8.3-14.1-.5-.7-1.6-1.1-2.7-1.1H4.4z",
    className: "catering_off_svg__st5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 33.8,
    r: 3.9,
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.357 63.235v-59h13.9v59zM45.681 63.26v-59h13.9v59zM28.006 63.284v-59h13.9v59zM10.035 63.313v-59h13.9v59z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "catering_off_svg__XMLID_4_",
    d: "M88.1 33.9c-.6 1.4-1.6 4.2-1.4 5.4.2 1.1.3 1.9 1.8 1.9 1.4 0 3.4-2.2 3.5-3.2.1-1.3-1.4-3.1-2.2-4.1-.5.3-.2 0-.9 0-.4.1-.4.2-.8 0",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "catering_off_svg__XMLID_3_",
    d: "M82.1 31.7c.7 1 3.9 1.4 5.3 1.3v-.3c0-.9-.4-.7.3-1.2-.6-1.3-2.3-3.9-2.7-4.4-.8-.8-1.6-1.2-2.6-.1-1.1 1-1.1 3.9-.3 4.7",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "catering_off_svg__XMLID_2_",
    d: "M90.4 33.2c1.5.1 4.9-.6 5.5-.9 1-.4 1.7-1 1.1-2.4-.6-1.3-3.3-2.4-4.3-2-.6.2-2.2 2.2-2.8 3.2.7.5 1 1.6 0 1.7-.8.2.5.3.5.4",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "catering_off_svg__XMLID_1_",
    d: "M90.7 32.6c0-1-.8-1.9-1.9-1.9-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9 1.1-.1 1.9-.9 1.9-1.9m-1.3 0c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.9,
    cy: 32.6,
    r: 1,
    className: "catering_off_svg__st4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "catering_off_svg__cater_x5F_off"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.9 53.8 14.3-12.5-15-13.1 14.6-12.7L23.7 4.2H4.4v58.9h29.2z",
    className: "catering_off_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1 5.3c-.5-.7-1.6-1.1-2.7-1.1H34.7l13.7 11.9L34 28.6l14.4 12.5-14.5 12.7 10.7 9.3h78.8c1.1 0 2.2-.4 2.7-1 0 0 8.3-13.2 8.3-13.9V19.5c0-.9-8.3-14.2-8.3-14.2",
    className: "catering_off_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2 41.3 22.9 53.8l14.4-12.5zM42.7 36.5l.2-.1 5.5 4.8L34 28.6l-.2.1z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.2 28.2.6.5.2-.1-.7-.5z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5 33.4-.1.1-5.5-4.8.1-.1-.1-.1 5.5-4.7h.1l8.9-7.7-.6-.6-14.6 12.7 15 13.1.2-.1z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.9 28.7 5.5 4.8.1-.1-5.5-4.8z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.4 23.8-5.5 4.7.1.1 5.5-4.8zM42.2 10.8l5.5 4.8-14.4 12.5.7.5 14.4-12.5L34.7 4.2h-11l13.1 11.3z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5 23.8 4.8 4.3 14.4-12.5-5.5-4.8-5.4 4.7.6.6zM42.7 36.5l-8.9-7.8-5.3 4.7 8.9 7.8-.2.1h.1z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 28.6 5.5 4.8 5.3-4.7-.6-.5.1-.1-4.8-4.3zM48.4 41.2l-20 17.4-5.5-4.8 10.7 9.3h11l-10.7-9.3z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.7 36.5 5 4.3-5.5 4.8-4.9-4.3-14.4 12.5 5.5 4.8 20-17.4-5.5-4.8z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.2 45.6 5.5-4.8-5-4.3-5.4 4.8zM56 41.3 41.6 53.8zM61.5 36.5l.1-.1 5.5 4.8-14.4-12.6-.1.1z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.9 28.2.7.5.1-.1-.6-.5z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.2 33.4-.1.1-5.5-4.8.1-.1-.1-.1 5.5-4.7h.1l8.9-7.7-.6-.6L41 28.2l15 13.1.1-.1z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.6 28.7 5.5 4.8.1-.1-5.5-4.8z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.1 23.8-5.5 4.7.1.1 5.5-4.8zM60.9 10.8l5.5 4.8-14.3 12.5.6.5 14.4-12.5L53.5 4.2h-11l13 11.3z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.2 23.8 4.9 4.3 14.3-12.5-5.5-4.8-5.4 4.7.6.6zM61.5 36.5l-8.9-7.8-5.4 4.7 8.9 7.8-.1.1z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.7 28.6 5.5 4.8 5.4-4.7-.7-.5.2-.1-4.9-4.3zM67.1 41.2l-20 17.4-5.5-4.8 10.7 9.3h11l-10.7-9.3z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.5 36.5 4.9 4.3-5.5 4.8-4.9-4.3-14.4 12.5 5.5 4.8 20-17.4-5.5-4.8z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.9 45.6 5.5-4.8-4.9-4.3-5.5 4.8z",
    className: "catering_off_svg__st4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.9,
    cy: 34.1,
    r: 3.9,
    className: "catering_off_svg__st4"
  }))));
};
export default SvgCateringOff;